import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DAPPROVER_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchAct = (get: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: get,
});
export const remove = (remove: any) => ({
    type: 'FETCH_REMOVE_SUCCESS',
    payload: remove,
});



export const fetchData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1};
            const apiname = DAPPROVER_API.doctor_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAct(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const removeData = (doctorid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,doctorid:doctorid};
            const apiname = DAPPROVER_API.doctor_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(remove(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

